import React from 'react';

const NextJs = () => {
    return (
        <>
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb_box text-center">
                                <h2 className="breadcrumb-title">Next.js Development</h2>
                                <ul className="breadcrumb-list">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/technologies">Technologies</a></li>
                                    <li className="breadcrumb-item active">Next.js</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-wrapper section-space--ptb_100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="content-area">
                                <div className="service-details-content">
                                    <h1>Next.js Development Excellence</h1>
                                    
                                    <p className="lead">Next.js is a production-ready React framework that enables developers to build full-stack web applications with exceptional performance, SEO optimization, and seamless developer experience. Built by Vercel, it's trusted by companies like Netflix, TikTok, Hulu, and Nike for their most critical web applications.</p>

                                    <h3 className="mt-50">What Makes Next.js Powerful?</h3>
                                    <p>Next.js combines the flexibility of React with server-side capabilities, enabling you to create applications that load faster, rank better in search engines, and provide superior user experiences. It eliminates the complexity of traditional server setup while maintaining full control over your backend logic.</p>

                                    <h3 className="mt-40">Key Features & Capabilities</h3>
                                    <ul>
                                        <li><strong>Server-Side Rendering (SSR):</strong> Generate HTML on the server for faster initial page loads and improved SEO</li>
                                        <li><strong>Static Site Generation (SSG):</strong> Pre-render pages at build time for blazing-fast performance</li>
                                        <li><strong>Incremental Static Regeneration (ISR):</strong> Update static pages without rebuilding the entire site</li>
                                        <li><strong>API Routes:</strong> Build backend APIs directly within your Next.js application</li>
                                        <li><strong>Image Optimization:</strong> Automatic image optimization with responsive sizing and modern formats</li>
                                        <li><strong>Automatic Code Splitting:</strong> Optimize bundle size with intelligent code splitting</li>
                                        <li><strong>Built-in CSS & Sass Support:</strong> Style your components with zero configuration</li>
                                        <li><strong>TypeScript Support:</strong> Native TypeScript support for type-safe development</li>
                                    </ul>

                                    <h3 className="mt-40">Real-World Use Cases</h3>
                                    <p><strong>E-Commerce Platforms:</strong> Next.js powers high-performance e-commerce sites with dynamic product catalogs, fast checkout experiences, and excellent SEO for product discovery.</p>
                                    <p><strong>Content Platforms:</strong> Publishing platforms benefit from SSG for content pages, reducing server load while maintaining fresh dynamic data.</p>
                                    <p><strong>SaaS Applications:</strong> Build complete software-as-a-service platforms with integrated authentication, API routes, and real-time features.</p>

                                    <h3 className="mt-40">AppCore's Next.js Success Stories</h3>
                                    <div className="case-study-box mt-30">
                                        <h5>Case Study: High-Performance E-Commerce Platform</h5>
                                        <p>We developed a full-stack e-commerce solution using Next.js that achieved:</p>
                                        <ul>
                                            <li>⚡ 95+ Google Lighthouse Score</li>
                                            <li>📈 40% increase in conversion rates</li>
                                            <li>🔍 #1 ranking for target keywords within 3 months</li>
                                            <li>⏱️ Average page load time under 1.2 seconds</li>
                                        </ul>
                                    </div>

                                    <h3 className="mt-40">Technical Excellence</h3>
                                    <p>AppCore leverages Next.js to build scalable applications with optimal performance. Our team uses advanced patterns including:</p>
                                    <ul>
                                        <li>Custom middleware for authentication & analytics</li>
                                        <li>Incremental Static Regeneration for dynamic content</li>
                                        <li>API route optimization for backend performance</li>
                                        <li>Advanced image optimization strategies</li>
                                        <li>Integration with headless CMS and databases</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar-area">
                                <div className="sidebar-widget mb-50">
                                    <h5 className="widget-title mb-30">Technology Stack</h5>
                                    <ul className="sidebar-list">
                                        <li><img src="/assets/images/Symbol/sort/react-js.png" width={30} alt="React" /> React & Next.js</li>
                                        <li><img src="/assets/images/Symbol/ts.png" width={30} alt="TypeScript" /> TypeScript</li>
                                        <li><img src="/assets/images/Symbol/sort/nodejs.png" width={30} alt="Node" /> Node.js Backend</li>
                                        <li><img src="/assets/images/Symbol/sort/cloud1.png" width={30} alt="Cloud" /> Cloud Deployment</li>
                                    </ul>
                                </div>

                                <div className="sidebar-widget">
                                    <h5 className="widget-title mb-30">Performance Metrics</h5>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Average Load Time</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>~1.2s</p>
                                    </div>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Lighthouse Score</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>95+</p>
                                    </div>
                                    <div className="metric-item">
                                        <p className="metric-label">SEO Optimization</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>Excellent</p>
                                    </div>
                                </div>

                                <div className="sidebar-widget mt-50">
                                    <h5 className="widget-title mb-30">Why Choose AppCore for Next.js?</h5>
                                    <p className="small">Our expert team has built 50+ Next.js applications serving millions of users globally. We combine cutting-edge performance optimization with production-ready practices.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NextJs;
